import localForage from "localforage";

export const GEO_FETCH_COUNTRIES = "GEO_FETCH_COUNTRIES";
export const GEO_FETCH_COUNTRIES_SUCCESS = "GEO_FETCH_COUNTRIES_SUCCESS";
export const GEO_FETCH_COUNTRIES_ERROR = "GEO_FETCH_COUNTRIES_ERROR";

export const GEO_FETCH_REGIONS = "GEO_FETCH_REGIONS";
export const GEO_FETCH_REGIONS_SUCCESS = "GEO_FETCH_REGIONS_SUCCESS";
export const GEO_FETCH_REGIONS_ERROR = "GEO_FETCH_REGIONS_ERROR";

export const GEO_FETCH_CITIES = "GEO_FETCH_CITIES";
export const GEO_FETCH_CITIES_SUCCESS = "GEO_FETCH_CITIES_SUCCESS";
export const GEO_FETCH_CITIES_ERROR = "GEO_FETCH_CITIES_ERROR";

export const geo_fetchCountries = (params) => {
  return { 
      type: GEO_FETCH_COUNTRIES, 
      payload: {
          request: {
              url: 'geo/countries/'
          },
          options: {
              onSuccess({ getState, dispatch, response }) {
                 localForage.setItem('countries', response.data).then((response) => {
                     dispatch({ type: GEO_FETCH_COUNTRIES_SUCCESS, payload: response });
                 })
              }, 
              onError({ getState, dispatch, error }) {
                 dispatch({ type: GEO_FETCH_COUNTRIES_ERROR, payload: error.message });
              },
          }
      } 
  }
};

export const geo_fetchRegions = (country_id) => {
  return { 
      type: GEO_FETCH_REGIONS, 
      payload: {
          request: {
              url: 'geo/countries/' + country_id + '/regions/',
          },
          options: {
              onSuccess({ getState, dispatch, response }) {
                 localForage.setItem('regions_' + country_id, response.data).then((response) => {
                     dispatch({ type: GEO_FETCH_REGIONS_SUCCESS, payload: response });
                 })
              }, 
              onError({ getState, dispatch, error }) {
                 dispatch({ type: GEO_FETCH_REGIONS_ERROR, payload: error.message });
              },
          }
      } 
  }
};

export const geo_fetchCities = (country_id, region_id) => {
  return { 
      type: GEO_FETCH_CITIES, 
      payload: {
          request: {
            url: 'geo/countries/' + country_id + '/regions/' + region_id + '/cities/',
          },
          options: {
              onSuccess({ getState, dispatch, response }) {
                 localForage.setItem('cities_' + region_id, response.data).then((response) => {
                     dispatch({ type: GEO_FETCH_CITIES_SUCCESS, payload: response });
                 })
              }, 
              onError({ getState, dispatch, error }) {
                 dispatch({ type: GEO_FETCH_CITIES_ERROR, payload: error.message });
              },
          }
      } 
  }
};


// WEBPACK FOOTER //
// ./src/redux/actions/geoActions.js